
export default {
    tasks: {},
    tree: {},
    treeTasks: {},
    expandedNodes: {},
    loaded: {},
    taskNotification: {},
    activeTaskID: 0,
    copyTaskID: 0,
    treeNotificationFilter: false,
    activeTaskField: {},
    tasksListMode: "list",
    tasksListQuery: "",
    currentTask: 0,
    lastUpdateTime: 0,
    filterByTasks: {},
    updateHash: 0,
    tasksListTags: []
}
